module.exports = __webpack_public_path__ + "static/robesnmore-right-632a6afa35c013d9dbde11466a70f058.png";